import type { CurrentUserVM } from "../models/vm/currentUserVm";
import { apiPost, backendGet, backendPost } from "../shared/api";
import { WebLoginDTO } from "../models/dto/webLoginDto";

export const loginService = {
    doLogin(dto: WebLoginDTO): Promise<CurrentUserVM> {
        return apiPost<CurrentUserVM, WebLoginDTO>("/auth/weblogin", dto);
    },
    signIn(vm: CurrentUserVM) {
        return backendPost("/auth/signin", { token: vm.token })
    },
    signOut() {
        return backendGet("/auth/signout");
    }
}